// extracted by mini-css-extract-plugin
export default {"description":"styles_description__gA0P4","gridItem":"styles_gridItem__-043l","actions":"styles_actions__bgT6J"};